import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';
// import { history } from '../../_helpers';


const initialState = { isSignUpCompletedLoading: true, data: '', error: false };

export function isSignUpCompletedReducer(state = initialState, action) {

    switch (action.type) {
        case userProfileConstants.REQUEST_SIGNUP_COMPLETED:
            return {
                isSignUpCompletedLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_SIGNUP_COMPLETED:

            //   history.push('/login');
            return {
                isSignUpCompletedLoading: false,
                data: action.data,
                error: false
            };

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/isSignUpCompleted.reducer.js